export const convertSnakeCaseToReadable = (snakeCaseString) => {
  if (!snakeCaseString) return '';

  return snakeCaseString
    .replace(/_/g, ' ') // Replace underscores with spaces
    .split(' ') // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words back into a single string
};

export const capitaliseString = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const stripSlashes = (str) => {
  return (str || '').replace(/^\/+|\/+$/g, '');
};

export const humanizeCamelCase = (str) => {
  return str
    .replace(/([A-Z])/g, ' $1') // Insert a space before each uppercase letter
    .replace(/^./, function (match) {
      return match.toUpperCase();
    }) // Capitalize the first letter
    .trim(); // Remove any leading or trailing spaces
};
